<template>
  <div style="min-height: 100vh" id="id_services">
    <div class="quote">
      <div style="background: #000000ad !important">
        <a-row>
          <a-col :xs="24" :sm="24" :md="24" :lg="24">
            <div class="text-h1 text-white text-center">
              {{ $t("header.service") }}
            </div>
          </a-col>
        </a-row>
        <a-row
          :gutter="32"
          class="flex flex-center"
          style="max-width: 1400px; margin: 0 auto"
        >
          <a-col :xs="24" :sm="24" :md="8" :lg="8">
            <a-card
              style="border: none; margin: 50px auto; margin-top: 0"
              class="my-card text-center box-shadow"
              flat
              bordered
            >
              <img
                src="/statics/images/battery2.png"
                style="
                  height: 350px;
                  width: 350px;
                  margin: -25px -25px 25px -25px;
                "
              />

              <div>
                <div class="text-h2 text-theme">
                  {{ $t("home.service.card1.title") }}
                </div>
                <div class="text-caption text-grey-9">
                  {{ $t("home.service.card1.desc") }}
                </div>
              </div>
            </a-card>
          </a-col>
          <a-col :xs="24" :sm="24" :md="8" :lg="8">
            <a-card
              style="border: none; margin: 50px auto; margin-top: 0"
              class="my-card text-center box-shadow"
              flat
              bordered
            >
              <img
                src="/statics/images/battery.png"
                style="
                  height: 350px;
                  width: 350px;
                  margin: -25px -25px 25px -25px;
                "
              />

              <div>
                <div class="text-h2 text-theme">
                  {{ $t("home.service.card2.title") }}
                </div>
                <div class="text-caption text-grey-9">
                  {{ $t("home.service.card2.desc") }}
                </div>
              </div>
            </a-card>
          </a-col>
          <a-col :xs="24" :sm="24" :md="8" :lg="8">
            <a-card
              style="border: none; margin: 50px auto; margin-top: 0"
              class="my-card text-center box-shadow"
              flat
              bordered
            >
              <img
                src="/statics/images/plant.png"
                style="
                  height: 350px;
                  width: 350px;
                  margin: -25px -25px 25px -25px;
                "
              />

              <div>
                <div class="text-h2 text-theme">
                  {{ $t("home.service.card3.title") }}
                </div>
                <div class="text-caption text-grey-9">
                  {{ $t("home.service.card3.desc") }}
                </div>
              </div>
            </a-card>
          </a-col>
        </a-row>
      </div>
    </div>

    <div>
      <a-row>
        <a-col :xs="24" :sm="24" :md="24" :lg="24">
          <div class="text-h1 text-center">
            {{ $t("home.service.app") }}
            <br />
            <span class="text-center text-grey text-h6"></span>
          </div>
        </a-col>
      </a-row>
      <div class="q-pa-xl">
        <a-row :gutter="32" style="max-width: 1500px; margin: 0 auto">
          <a-col
            :xs="24"
            :sm="24"
            :md="8"
            :lg="8"
            v-for="index in 5"
            :key="index"
          >
            <a-card class="box-shadow">
              <div class="text-theme flex" style="margin: -24px">
                <div
                  style="
                    width: 110px;
                    height: 110px;
                    line-height: 110px;
                    text-align: center;
                    margin-right: 30px;
                    background-color: rgb(123 170 74);
                  "
                >
                  <car v-if="index == 1" fillColor="white" size="110px"></car>
                  <solar
                    v-if="index == 2"
                    fillColor="white"
                    size="110px"
                  ></solar>
                  <truck
                    v-if="index == 3"
                    fillColor="white"
                    size="110px"
                  ></truck>
                  <robot
                    v-if="index == 4"
                    fillColor="white"
                    size="110px"
                  ></robot>
                  <ellipsis
                    v-if="index == 5"
                    fillColor="white"
                    size="110px"
                  ></ellipsis>
                </div>

                <div>
                  <div
                    class="text-h2 text-grey text-uppercase"
                    :style="
                      $t('home.service.app' + index + '.desc1') == ''
                        ? 'line-height:100px'
                        : ''
                    "
                  >
                    {{ $t("home.service.app" + index + ".title") }}
                  </div>
                  <div
                    class="text-grey"
                    v-if="$t('home.service.app' + index + '.desc1') != ''"
                  >
                    <ul style="margin: 0; margin-left: 1em; padding: 0">
                      <li>{{ $t("home.service.app" + index + ".desc1") }}</li>
                      <li>{{ $t("home.service.app" + index + ".desc2") }}</li>
                      <li>{{ $t("home.service.app" + index + ".desc3") }}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </a-card>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import Car from "vue-material-design-icons/Car.vue";
import Solar from "vue-material-design-icons/SolarPanel.vue";
import Truck from "vue-material-design-icons/Truck.vue";

import Robot from "vue-material-design-icons/Robot.vue";
import Ellipsis from "vue-material-design-icons/DotsHorizontal.vue";
export default {
  name: "Service",
  components: {
    Car,
    Solar,
    Truck,

    Robot,
    Ellipsis,
  },
};
</script>

<style scoped>
.quote {
  background: url(/statics/images/parallax.png);
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
}
</style>
